import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface IPmduPowerState {
    data: Array<IPmduPowerMeter> | null;
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    showLoading: ILoading;
    isLoading: boolean;
    isSuccess: boolean;
    details: IPmduPowerMeter | null;
    currentPower: ICurrentPowerConsumption | null;
    currentSARMPower: ISARMBladePower | null;
    weeklyPower: object | null;
    monthlyPower: IMonthlyPowerConsumption | null
}

// Define the initial state using that type
const initialState: IPmduPowerState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null,
    currentPower: null,
    currentSARMPower: null,
    weeklyPower: null,
    monthlyPower: null
};

export const pmduPowerSlice = createSlice({
    name: 'pmduPower',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replacePmduPower: (state, action) => {
            const { data, pageSize, pageNumber, totalCount, currentSARMPower, currentPower, details } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
            state.currentSARMPower = currentSARMPower;
            state.currentPower = currentPower;
            state.details = details;
        },
        setPmduPowerDetails: (state, action) => {
            state.details = action.payload.data;
        },
        setPmduCurrentPower: (state, action) => {
            state.currentPower = action.payload.data;
        },        
        setPmduSARMCurrentPower: (state, action) => {
            state.currentSARMPower = action.payload.data;
        },
        setWeeklyPowerDetails: (state, action) => {
            state.weeklyPower = action.payload.data;
        },
        setMonthlyPowerDetails: (state, action) => {
            state.monthlyPower = action.payload.data;
        }
    },
});

export const pmduPowerActions = pmduPowerSlice.actions;

export default pmduPowerSlice.reducer;
